import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { uiActions } from '../../store/ui-slice';
import { form3Actions } from '../../store/forms/form3-slice';

import Form3PlanCard from './Form3PlanCard';
import Button from '../commons/Button';

import { doNavigation, logResponseFromAPI } from '../../utils/helper-functions';
import { appConfigActions } from '../../store/appConfig-slice';

const Form3 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);
  const plansObject = useSelector((state) => state.form2.plans);
  const [planAmplia, planLimitada, planBasica] = Object
    .keys(plansObject)
    .map((key) => plansObject[key]);
  const paymentPeriodicities = Object
    .keys(planAmplia.forma_pagos)
    .reverse();
  const [selectedPeriodicity, setSelectedPeriodicity] = useState(paymentPeriodicities[3]);
  const [displayedPlan, setDisplayedPlan] = useState(planAmplia.plan?.name || '');

  const navigationHandler = (direction) => {
    doNavigation(currentStep, direction, navigate, dispatch, uiActions);
  };

  const selectPlanHanlder = (
    planName,
    idCobertura,
    firstPayment,
    paymentAmount,
    totalPayment,
    coverageObject,
  ) => {
    const randomNumber = Math.floor((Math.random() * 1000) + 1); // between 1 and 1000
    const timestamp = new Date().valueOf();
    const idProcess = `${timestamp}-${idCobertura}-${randomNumber}`;

    setDisplayedPlan('planName');
    dispatch(appConfigActions.setIdProcess({ idProcess }));
    dispatch(form3Actions.setForm3Data({
      planName,
      selectedPeriodicity,
      firstPayment,
      paymentAmount,
      totalPayment,
      coverageObject,
    }));
    logResponseFromAPI(
      idProcess,
      'Quote selection',
      0,
      'Quote selected',
      'none',
      plansObject,
    );
    navigationHandler('forward');
  };

  return (
    <div className="quoter-form plan-selector">
      <h2 className="form-title">¡Listo! Estas opciones son las que más te convienen:</h2>
      <p className="form-subtitle">Cotiza tu seguro de auto hasta en 12 mensualidades</p>
      <h2 className="form-title">Elige un plan</h2>
      <div className="tab-container">
        <button
          type="button"
          className={`tab ${displayedPlan === 'Basica' && '-displayed'}`}
          onClick={() => setDisplayedPlan('Basica')}>
          {planBasica.plan.name}
        </button>
        <button
          type="button"
          className={`tab ${displayedPlan === 'Amplia' && '-displayed'}`}
          onClick={() => setDisplayedPlan('Amplia')}>
          {planAmplia.plan.name}
        </button>
        <button
          type="button"
          className={`tab ${displayedPlan === 'Limitada' && '-displayed'}`}
          onClick={() => setDisplayedPlan('Limitada')}>
          {planLimitada.plan.name}
        </button>
      </div>
      <div className="payment-selection">
        <div className="form-fields">
          <div className="field">
            <label htmlFor="brand">Forma de pago</label>
            <select value={selectedPeriodicity} onChange={(event) => setSelectedPeriodicity(event.target.value)}>
              {paymentPeriodicities.map((element) => (
                <option key={element} value={element}>
                  {element}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="plan-container">
        <Form3PlanCard
          plan={planBasica}
          displayedOnMobile={displayedPlan === 'Basica'}
          selectedPeriodicity={selectedPeriodicity}
          onSelectPlan={selectPlanHanlder} />
        <Form3PlanCard
          plan={planAmplia}
          displayedOnMobile={displayedPlan === 'Amplia'}
          selectedPeriodicity={selectedPeriodicity}
          highlighted
          onSelectPlan={selectPlanHanlder} />
        <Form3PlanCard
          plan={planLimitada}
          displayedOnMobile={displayedPlan === 'Limitada'}
          selectedPeriodicity={selectedPeriodicity}
          onSelectPlan={selectPlanHanlder} />
      </div>
      <div className="form-buttons">
        <Button
          onClick={() => navigationHandler('backward')}
          type="button"
          label="Regresar"
          buttonClasses="-secondary"
          iconPosition="before"
          iconClasses="arrow-left" />
      </div>
    </div>
  );
};

export default Form3;
